import { render } from "./error.vue?vue&type=template&id=688edc10&scoped=true"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"

import "./error.vue?vue&type=style&index=0&id=688edc10&scoped=true&lang=css"

import exportComponent from "/Users/min/Desktop/lambda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688edc10"]])

export default __exports__